import { Action, createReducer, on } from '@ngrx/store';
import {
    clearLocalFacilityAutomatchSettings,
    getBrandsFailure,
    getBrandsSuccess,
    getDocDueDateFailure,
    getDocDueDateSuccess,
    getFacilitiesFailure,
    getFacilitiesSuccess,
    getFacilityAutomatchSettingsFailure,
    getFacilityAutomatchSettingsSuccess,
    getFacilityClientPortalVisibilitySettingsFailure,
    getFacilityClientPortalVisibilitySettingsSuccess,
    getFacilityFailure,
    getFacilitySuccess,
    getVmsLookupsFailure,
    getVmsLookupsSuccess,
    setFacilitiesFilter,
    updateDocDueDateFailure,
    updateFacilityAutomatchSettingsFailure,
    updateFacilityAutomatchSettingsSuccess,
    updateFacilityClientPortalVisibilitySettingsFailure
} from '../actions/facilities.actions';
import { FacilitiesState } from '../state/facilities.state';

const initialState: FacilitiesState = {
    facility: null,
    facilities: null,
    filter: {
        filter: {},
        sort: { field: 'id', dir: 'desc' },
        skip: 0,
        pageSize: 25
    },
    clientPortalVisibilitySettings: undefined,
    docDueDates: undefined,
    error: null,
    brands: [],
    vmsLookups: [],
    automatchSettings: undefined
};

const reducer = createReducer(
    initialState,

    on(getFacilitySuccess, (state, action) => ({
        ...state,
        facility: action.facility,
        error: ''
    })),

    on(getFacilitiesSuccess, (state, action) => ({
        ...state,
        facilities: action.facilities,
        error: ''
    })),

    on(setFacilitiesFilter, (state, action) => ({
        ...state,
        filter: action.filter,
        facilities: null,
        error: ''
    })),

    on(getFacilityClientPortalVisibilitySettingsSuccess, (state, action) => ({
        ...state,
        clientPortalVisibilitySettings: action.clientPortalVisibilitySettings
    })),

    on(getDocDueDateSuccess, (state, action) => ({
        ...state,
        docDueDates: action.docDueDate
    })),

    on(getBrandsSuccess, (state, action) => ({
        ...state,
        brands: action.brands
    })),

    on(getVmsLookupsSuccess, (state, action) => ({
        ...state,
        vmsLookups: action.vmsLookups
    })),

    on(getFacilityAutomatchSettingsSuccess, (state, action) => ({
        ...state,
        automatchSettings: action.settings,
        error: undefined
    })),

    on(getFacilityAutomatchSettingsFailure, (state, action) => ({
        ...state,
        automatchSettings: undefined,
        error: action.error
    })),

    on(updateFacilityAutomatchSettingsSuccess, (state, action) => ({
        ...state,
        automatchSettings: action.settings,
        error: undefined
    })),

    on(updateFacilityAutomatchSettingsFailure, (state, action) => ({
        ...state,
        error: { ...action.error as any }
    })),

    on(clearLocalFacilityAutomatchSettings, (state) => ({
        ...state,
        automatchSettings: undefined,
        error: undefined
    })),

    on(
        getFacilityFailure,
        getFacilitiesFailure,
        getFacilityClientPortalVisibilitySettingsFailure,
        updateFacilityClientPortalVisibilitySettingsFailure,
        getDocDueDateFailure,
        updateDocDueDateFailure,
        getBrandsFailure,
        getVmsLookupsFailure,
        (state, action) => ({
            ...state,
            error: action.error
        })
    )
);

export function facilitiesReducer(state: FacilitiesState | undefined, action: Action) {
    return reducer(state, action);
}
